<template>
  <div
    v-show="LK.showContent"
    v-if="LK.loadApp"
    class="main"
  >
    <RouterView />
    <NotificationBlock />
  </div>
  <GlobalLoader v-if="store.isPageLoading" />
</template>

<script setup>
import {useLK} from "@/controllerLK/LKstore";
import GlobalLoader from "@/components/UI/Preloader/GlobalLoader.vue";
import {useStore} from "@/store";
import NotificationBlock from "@/components/UI/Notification/NotificationBlock.vue";
import {onMounted} from "vue";

const store = useStore();
const LK = useLK();

onMounted(() => {
  deleteHeaderMenu();
});

const deleteHeaderMenu = () => {
  // Удаление правой части шапки ЛК.
  const projectSelector = document.querySelector(".project__title");
  const languageSelector = document.querySelector(".language-selector");
  if (projectSelector || languageSelector) {
    projectSelector.remove();
    languageSelector.remove();
  } else {
    setTimeout(deleteHeaderMenu, 2500);
  }
};
</script>

<style lang="scss">
#app {
  height: calc(100% - 113px);
  max-height: calc(100% - 113px);
}

.main {
  height: 100%
}
</style>
